import { render, staticRenderFns } from "./PageBack.vue?vue&type=template&id=328ee60d&"
import script from "./PageBack.vue?vue&type=script&lang=js&"
export * from "./PageBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports